export default __webpack_public_path__ + "static/media/IMG_00002.b45638e3.jpeg";